import AdminTopNavLinks from './AdminTopNavLinks';

export default AdminTopNavLinks;
